// extracted by mini-css-extract-plugin
export var AccordionFaq = "AccordionFaq-module--AccordionFaq--Awnbl";
export var FaqHeader = "AccordionFaq-module--FaqHeader--Mk-GM";
export var BiggerQuestion = "AccordionFaq-module--BiggerQuestion--vtRco";
export var disclaimer = "AccordionFaq-module--disclaimer--r1mZx";